import styled from 'styled-components';
import TickIcon from '../../../icons/Tick';

export const TickIco = styled(TickIcon)``;
export const Hd16 = styled.div`
  font-size: 10px;
`;

export const Reset = styled.span`
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  color: ${props => (props.clickable ? '#2276e3' : '#8e93ab')};
  opacity: ${props => (props.clickable ? '1' : '0.3')};
  font-weight: ${props => (props.clickable ? 'bold' : 'normal')};
`;

export const FltHpyFilter = styled.div`
  width: 285px;
  float: left;
  height: calc(100vh - 186px);
  overflow-y: auto;
  .brdrBot {
    border-bottom: 1.5px solid #f0f0f0;
  }
`;

export const FilterWrap = styled.div`
  background: #ffffff;
  border-radius: 0px 8px 8px 0px;
`;

export const PolicyTag = styled.div`
  background: #ffffff;
  border-radius: 0px 8px 8px 0px;
  border-left: 5px solid #f11919;
  padding: 10px 15px;
  & .tag {
    background: rgba(241, 25, 25, 0.1);
    padding: 5px 7px;
    color: #f11919;
    font-weight: 700;
    font-size: 9px;
    border-radius: 2px;
  }
`;

export const StickyHpy = styled.div`
  position: sticky;
  top: 0;
  z-index: 6;
  /* ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
  ${props => props.theme.justifyStart};
  color: ${props => props.theme.colors.goWhite.base}; */
`;

export const FilterTypeWrap = styled.div`
  padding: 20px 20px 0;
`;

export const FltHpyStp = styled.span`
  width: 100%;
  border-radius: 3px;
  color: #0a2549;
  background-color: #f3f6f8;
  cursor: pointer;
  height: 28px;
  .stopTxt {
    padding: 4px 0 0 3px;
    font-size: 10px;
  }
`;

export const CustCheck1 = styled.input`
  &:not(:checked),
  &:checked {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &:checked ~ span {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: all 0.2s ease;
    background-color: #2276e3;
    color: #ffffff;
  }
  &:checked ~ ${FltHpyStp} {
    font-weight: 500;
  }
  &:checked ~ ${FltHpyStp}.fltrStops,&:checked ~ ${FltHpyStp}.fltrStops b {
    color: white;
  }
  &:checked ~ ${FltHpyStp} .stopTxt {
    font-size: 10px;
    font-weight: normal;
  }
`;

export const FltrStpLabel = styled.label`
  flex-shrink: 0;
  padding-bottom: 10px;
  &:nth-child(odd) {
    padding-right: 15px;
  }
`;
// preferred airlines
export const PreferredRow = styled.div`
  width: 100%;
  ${props => props.theme.dF};
  ${props => props.theme.justifyBetween};
  ${props => props.theme.alignItemsCenter};
  padding-bottom: ${props => props.theme.spacing.custom(20)};
`;

export const LeftCol = styled.div`
  ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
`;

export const ChckAirln = styled.label`
  position: relative;
  ${props => props.theme.dF};
  ${props => props.theme.alignItemstart};
  cursor: pointer;
`;

export const CheckBox = styled.span`
  position: relative;
  ${props => props.theme.flexCol};
  ${props => props.theme.alignItemsCenter};
  ${props => props.theme.justifyCenter};
`;

export const CheckCustom = styled.input`
  display: none;
  &:checked ~ ${CheckBox} {
    background-color: #0069e2;
    border-color: #0069e2;
  }
  &:checked ~ ${CheckBox} ${TickIco} {
    opacity: 1;
    transform: scale(0.8);
    transition: all 0.2s ease;
  }
  & ~ ${CheckBox} {
    border: solid 1.5px #2276e3;
    width: 17px;
    height: 17px;
    border-radius: 3px;
    background-color: #ffffff;
    transition: all 0.2s ease;
    left: 0;
  }
  & ~ ${CheckBox} ${TickIco} {
    opacity: 0;
    transform: scale(0);
    transition: all 0.2s ease;
  }
`;

export const Airline = styled.span`
  font-size: ${props => props.theme.font.custom(14)};
`;

export const AirlineWrap = styled.span`
  ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
  padding-left: ${props => props.theme.spacing.custom(10)};
  &.multi {
    ${props => props.theme.flexCol};
    ${props => props.theme.alignItemsStart};
  }
`;
// filter slider
export const FltSldBase = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  .fltSld-target {
    border-radius: 4px;
    border: 1px solid #d3d3d3;
    box-shadow: inset 0 1px 1px #f0f0f0, 0 3px 6px -5px #bbb;
    margin-bottom: 16px;
    position: relative;
    direction: ltr;
    box-sizing: border-box;
    height: 7px;
  }
  .fltSld-handle {
    background: #2276e3;
    border-radius: 4px;
    width: 65px;
    height: 24px;
    color: #fff;
    font-weight: 700;
    padding: 6px 6px;
    box-shadow: none;
    border: none;
    &.fltSld-handle-0 {
      left: 0px;
      top: 14px;
      position: relative;
      margin-left: -9px;
      &:before {
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 0px solid transparent;
        border-bottom: 8px solid #2276e3;
        content: '';
        position: absolute;
        top: -7px;
        left: 2px;
      }
      /* &:after {
        content: ${props => props.onwardMinPrice} + '';
      } */
    }
    &.fltSld-handle-1 {
      left: 219px;
      top: -32px;
      &:before {
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 0px solid transparent;
        border-top: 8px solid #2276e3;
        content: '';
        position: absolute;
        bottom: -7px;
        right: 3px;
      }
      /* &:after {
        content: ${props => props.onwardMaxPrice} + '';
      } */
    }
  }
  .fltSld-connect {
    bottom: 0;
    top: 0;
    -webkit-transition: background 450ms;
    transition: background 450ms;
  }
  .fltSld-connect-1 {
    /* background: #f57c32; */
    background-color: #2276e3;
    position: absolute;
    left: 0px;
    right: 0px;
    border-radius: 7px;
  }
  .fltSld-connect-0,
  .fltSld-connect-2 {
    /* background: #FAFAFA; */
    background: #e9e9e9;
  }
  .fltSld-connect-2 {
    display: none;
  }
`;

export const ToolTipWrapper = styled.span`
  position: relative;
  cursor: pointer;
  display: inline-block;
  padding-left: 5px;
  :hover .tooltiptext {
    opacity: 1;
  }
`;

export const ToolTip = styled.div`
  background: #fff;
  color: #666;
  top: 110%;
  left: 0px;
  box-shadow: 0 0 3px 0 rgb(0 0 0 / 30%);
  transition: all 0.25s ease-out;
  display: block;
  margin-bottom: 15px;
  opacity: 0;
  padding: 10px;
  pointer-events: none;
  position: absolute;
  min-width: 250px;
  -webkit-border-radius: 3px;
  z-index: 999999;

  line-height: 1.2 !important;
  cursor: pointer;
`;

export const TripSlider = styled.div`
  & .durationRangeOuter {
    width: 220px;
    margin: 0 auto;
  }

  & .fltSld-target {
    width: 270px;
    height: 4px;
    border: none;
    border-radius: 6px;
    background: #eee;
    margin-top: 42px;
    margin-left: -40px;

    &:before {
      content: '';
      position: absolute;
      width: 50px;
      height: 4px;
      left: 14px;
      top: 0px;
      background: #fff;
      z-index: 11;
    }
  }
  & .fltSld-connect {
    height: 4px;
  }

  & .fltSld-connect-0 {
    background: #2276e3;
  }

  & .fltSld-connect-1 {
    background: none;
  }

  & .fltSld-handle {
    background: #2276e3;
    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);
    border-radius: 4px;

    padding: 6px 2px;

    top: -37px;
    font-weight: 700;
    width: 65px;
    text-align: center;
    margin: 0 0 0 23px;
    border: none;
    color: white;
    padding: 5px;
    &:before {
      content: '';
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #2276e3;
      position: absolute;
      bottom: -7px;
      left: 29px;
    }
  }
`;
